export default __webpack_public_path__ + "static/media/Bracers of the Stormbringer.2a73c2e4.jpg";